/* global axios */
import ApiClient from './ApiClient';

class AiInsightsAPI extends ApiClient {
  constructor() {
    super('ai_insights', { accountScoped: true });
  }

  // Agents
  getAgents() {
    return axios.get(`${this.url}/agents`);
  }

  createAgent(payload) {
    return axios.post(`${this.url}/agents`, { agent: payload });
  }

  updateAgent(agentId, payload) {
    return axios.patch(`${this.url}/agents/${agentId}`, { agent: payload });
  }

  deleteAgent(agentId) {
    return axios.delete(`${this.url}/agents/${agentId}`);
  }

  // Analyses (conversation-scoped)
  getAnalyses(conversationId) {
    return axios.get(`${this.baseUrl()}/conversations/${conversationId}/ai_insights/analyses`);
  }

  runAnalysis(conversationId, agentId) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/ai_insights/analyses`,
      { agent_id: agentId }
    );
  }

  getAnalysis(conversationId, analysisId) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/ai_insights/analyses/${analysisId}`
    );
  }

  // Stats
  getStats(params = {}) {
    return axios.get(`${this.url}/stats`, { params });
  }
}

export default new AiInsightsAPI();
